import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Home from './pages/Home';
import Payment from './pages/Payment';
import CreateAppointment from './pages/CreateAppointment';
import './App.css';
import ExamsCalendar from './pages/ExamsCalendar';
import ExamsType from './pages/ExamsType';
import PatientForm from './pages/PatientForm';
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';

function App() {
  return (
    <div className="App">
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/create_appointment" component={CreateAppointment} />
        <Route exact path="/payment" component={Payment} />
        <Route
          exact
          path="/schedule_exam_appointments"
          component={ExamsCalendar}
        />
        <Route exact path="/type_exam_appointments" component={ExamsType} />
        <Route exact path="/patient_form" component={PatientForm} />
        <Redirect to="/" />
      </Switch>
    </div>
  );
}

// To monitor the app built environment
window.showEnv = () => {
  return {
    NODE_ENV: process.env.NODE_ENV,
    REACT_APP_SERVER_IP: process.env.REACT_APP_SERVER_IP,
    REACT_APP_MP_KEY: process.env.REACT_APP_MP_KEY,
  };
};

export default App;
